import script from "./RepairsSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./RepairsSidebar.vue?vue&type=script&setup=true&lang=js"

import "./RepairsSidebar.vue?vue&type=style&index=0&id=fdb31014&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdb31014"]])

export default __exports__